import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2, // 2 minutes - reduced API calls for stable data
      gcTime: 1000 * 60 * 5, // 5 minutes - keep cached for quick navigation
      retry: 2, // Retry failed requests twice
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff
      refetchOnWindowFocus: true, // Refetch when user returns to tab - ensures fresh data
      refetchOnReconnect: true, // Refetch after network recovery
      refetchOnMount: false, // Prevent redundant fetches - window focus covers most use cases
    },
    mutations: {
      retry: 1, // Retry mutations once on failure
    },
  },
});

// Query-specific configurations for optimal performance
export const queryOptions = {
  // User profiles - stable data that rarely changes
  userProfile: {
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 30, // 30 minutes
  },

  // Meetup details - semi-stable, may change with participant updates
  meetupDetails: {
    staleTime: 1000 * 60 * 2, // 2 minutes
    gcTime: 1000 * 60 * 10, // 10 minutes
  },

  // Meetup lists - dynamic data that changes frequently
  meetupList: {
    staleTime: 1000 * 30, // 30 seconds
    gcTime: 1000 * 60 * 5, // 5 minutes
  },

  // Places and search results - relatively stable
  places: {
    staleTime: 1000 * 60 * 10, // 10 minutes
    gcTime: 1000 * 60 * 60, // 1 hour
  },

  // Real-time data - short cache for immediate updates
  realtime: {
    staleTime: 1000 * 5, // 5 seconds
    gcTime: 1000 * 60, // 1 minute
  },
}; 